/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Virtual_TourInputs */

const cs_enum_virtual_tour = /** @type {(inputs: Enum_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtuální prohlídka`)
};

const en_enum_virtual_tour = /** @type {(inputs: Enum_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual tour`)
};

/**
* | output |
* | --- |
* | "Virtual tour" |
*
* @param {Enum_Virtual_TourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_virtual_tour = /** @type {((inputs?: Enum_Virtual_TourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Virtual_TourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_virtual_tour(inputs)
	return cs_enum_virtual_tour(inputs)
});